import script from "./doctorInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./doctorInfo.vue?vue&type=script&setup=true&lang=js"

import "./doctorInfo.vue?vue&type=style&index=0&id=b922edd4&lang=less"

const __exports__ = script;

export default __exports__